import { rankWith, uiTypeIs } from '@jsonforms/core';
import { Typography } from '@mui/material';
import React from 'react';
import { withJsonFormsLayoutProps } from '@jsonforms/react';

const TextRenderer = props => {
  const { uischema } = props;

  const variant = uischema.options?.variant;
  const color = uischema.options?.color;
  const style = uischema.options?.style;

  return (
    <Typography variant={variant} color={color} sx={{ ...style }}>{uischema.text}</Typography>
  );
};

export default withJsonFormsLayoutProps(TextRenderer);

export const TextTester = rankWith(1000, uiTypeIs('Text'));
